/**
 * athlix-landing.js
 * Shared JS for all Athlix landing page sections.
 * - Scroll-reveal (IntersectionObserver on .atx-rv)
 * - Staggered children inside .atx-rv-group
 */

(function () {
  'use strict';

  /* ── Scroll reveal ── */
  var revealObserver = new IntersectionObserver(
    function (entries) {
      entries.forEach(function (entry, i) {
        if (entry.isIntersecting) {
          setTimeout(function () {
            entry.target.classList.add('atx-on');
          }, i * 90);
          revealObserver.unobserve(entry.target);
        }
      });
    },
    { threshold: 0.07 }
  );

  function initReveal () {
    document.querySelectorAll('.atx-rv:not(.atx-on)').forEach(function (el) {
      revealObserver.observe(el);
    });
  }

  /* Run on page load and after Shopify section re-renders in the editor */
  document.addEventListener('DOMContentLoaded', initReveal);

  if (window.Shopify && window.Shopify.designMode) {
    document.addEventListener('shopify:section:load', initReveal);
    document.addEventListener('shopify:section:reorder', initReveal);
  }
})();
